import { CoreIcon } from '../core-icon';
import editSVG from '../../assets/icons/edit.svg';
import type { IconProps } from '../core-icon';

export const EditIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={editSVG} {...props} />;
};
